import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import ImageDisplay from "./ImageDisplay";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const useStyles = makeStyles((theme) => ({
    title: {
        marginLeft: "18px"
    },
    inputField: {
        margin: theme.spacing(2, 1),
        flex: 1,
    },
    chip: {
        margin: theme.spacing(1, 2),
    },
    chipList: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(20),
            height: theme.spacing(20),
        },
    },
    textField: {
        width: "100%"
    },
    image: {
        marginLeft: "20px",
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: theme.spacing(1)
    },
    paper: {
        position: 'relative',
        paddingBottom: theme.spacing(1)
    },
    deleteButton: {
        position: 'absolute',
        top: 4,
        right: 4,
        zIndex: 2,
        padding: 4,
    }
}));

const ListDetailsEditableChip = (props) => {
    const classes = useStyles();

    function handleWordChange(e) {
        const { value } = e.target;
        props.handleChange(props.index, value, 'word');
    }

    function handleImageChange(event, type, key) {
        if (type === 'image' && key === 'url') {
            props.handleChange(props.index, event.target.value, 'image');
        }
    }

    return (
        <Paper elevation={3} className={classes.paper}>
            <IconButton size="small" className={classes.deleteButton} onClick={() => props.requestDelete(props.index)} aria-label="delete">
                <CloseIcon fontSize="small" />
            </IconButton>
            <div className={classes.imageContainer}>
                <ImageDisplay
                    data={{ image: { url: props.image } }}
                    onChange={handleImageChange}
                    listCode={props.listCode}
                />
            </div>
            <TextField
                className={classes.inputField}
                value={props.word}
                type="text"
                onChange={handleWordChange}
            />
        </Paper>
    );
}

export default (props) => {
    const classes = useStyles();
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    function handleChange(i, newValue, type = 'word') {
        const list = [...props.listDetails[props.name]];
        if (type === 'word') {
            list[i].word = newValue;
        } else if (type === 'image') {
            list[i].image = newValue;
        }
        props.handleChange({target: {value: list, name: props.name}})
    }

    function handleAddChip() {
        const list = props.listDetails[props.name] ? [...props.listDetails[props.name]] : [];
        list.push({ word: "", image: "" });
        props.handleChange({target: {value: list, name: props.name}});
    }

    function handleDelete(i) {
        const list = props.listDetails[props.name] ? [...props.listDetails[props.name]] : [];
        list.splice(i, 1);
        props.handleChange({target: {value: list, name: props.name}});
    }

    function requestDelete(i) {
        setDeleteIndex(i);
        setConfirmOpen(true);
    }

    function confirmDelete() {
        if (deleteIndex !== null && deleteIndex !== undefined) {
            handleDelete(deleteIndex);
        }
        setDeleteIndex(null);
        setConfirmOpen(false);
    }

    function cancelDelete() {
        setDeleteIndex(null);
        setConfirmOpen(false);
    }

    let chipList = [];
    if (props.listDetails[props.name]) {
        chipList = props.listDetails[props.name].map((item, i) =>
            <ListDetailsEditableChip
                key={i}
                index={i}
                image={item.image}
                word={item.word}
                handleChange={handleChange}
                requestDelete={requestDelete}
                listCode={props.listDetails.code}
            />
        )
    }
    return (
        <>
            <h3 className={classes.title}>{props.title} ({chipList ? chipList.length : ""})</h3>
            <div className={classes.chipList}>
                {chipList}
            </div>

            <Dialog open={confirmOpen} onClose={cancelDelete} aria-labelledby="delete-confirm-dialog">
                <DialogTitle id="delete-confirm-dialog">Eyða spjaldi!</DialogTitle>
                <DialogContent>
                    Ertu viss um að þú viljir eyða þessu spjaldi?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} color="primary">Hætta við</Button>
                    <Button onClick={confirmDelete} color="secondary">Já</Button>
                </DialogActions>
            </Dialog>

            <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleAddChip}
                style={{ margin: '16px 18px' }}
            >
                Add
            </Button>
        </>
    );
}
